import { FormattedMessageWithTooltipHeaderRenderer } from '../../../components/HeaderRenderers';
import { gridNumberFormatter, formattedNumberValueGetter } from '../../../components/ValueFormatters';
import { normalizeColumnDefs } from '../../../utils';
import { leftPinnedColumn, numericColumn } from '../../columns';
import * as FIELDS from '../../fields';
import { CATEGORY_REPORT_ID } from './categoryReportId';

const categoryReportColumnDefinition = [
    {
        headerName: FIELDS.CATEGORY.label,
        field: FIELDS.CATEGORY.field,
        type: [leftPinnedColumn],
        headerValueGetter: FIELDS.CATEGORY.headerValueGetter || FormattedMessageWithTooltipHeaderRenderer,
        headerComponentParams: FIELDS.CATEGORY.headerComponentParams,
        cellRenderer: FIELDS.CATEGORY.cellRenderer,
        cellRendererParams: FIELDS.CATEGORY.renderParams,
        csvValueGetter: FIELDS.CATEGORY.csvValueGetter,
    },
    ...[
        FIELDS.CLICKS,
        FIELDS.VISIBLE_IMPRESSIONS,
        FIELDS.IMPRESSIONS,
        FIELDS.CPA,
        FIELDS.SPENT,
        FIELDS.CONVERSIONS,
        FIELDS.AVERAGE_CPC,
        FIELDS.CVR,
        FIELDS.VCTR,
        FIELDS.VCPM,
        FIELDS.CONVERSIONS_VALUE,
        FIELDS.ROAS,
    ].map(fieldConfig => ({
        headerName: fieldConfig.label,
        headerValueGetter: fieldConfig.headerValueGetter || FormattedMessageWithTooltipHeaderRenderer,
        headerComponentParams: fieldConfig.headerComponentParams,
        field: fieldConfig.field,
        type: [numericColumn],
        valueFormatter: gridNumberFormatter,
        cellRendererParams: fieldConfig.renderParams,
        csvValueGetter: fieldConfig.csvValueGetter || formattedNumberValueGetter,
        referenceColId: fieldConfig.referenceColId,
        permissions: fieldConfig.permissions,
        visibilityCondition: fieldConfig.visibilityCondition,
    })),
];

export default normalizeColumnDefs(categoryReportColumnDefinition, CATEGORY_REPORT_ID);
